import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { BsGithub, BsInstagram, BsLinkedin, BsApple, BsAndroid } from 'react-icons/bs';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer id='footer'>
            <Container>
                <Row className='align-items-center'>
                    <Col sm={6} className='text-center d-sm-none d-block'>
                        <img src='/assets/images/logo.png' alt='ShipShop' className='footerLogo' />
                        <p>High quality products are our first priority.</p>
                        <p>Copyrights 2023 &copy; ShipShop</p>
                        <hr className='my-5' />
                    </Col>
                    <Col sm={3} className='text-sm-start text-center'>
                        <h4>Download our App.</h4>
                        <p className='mb-3'>Download App for android and IOS mobile phone.</p>
                        <span>
                            <BsApple />
                        </span>
                        <span>
                            <BsAndroid />
                        </span>
                    </Col>
                    <Col sm={6} className='text-center d-sm-block d-none'>
                        <img src='/assets/images/logo.png' alt='ShipShop' className='footerLogo' />
                        <p>High quality products are our first priority.</p>
                        <p>Copyrights 2023 &copy; ShipShop</p>
                    </Col>
                    <Col sm={3} className='text-sm-end text-center mt-sm-0 mt-5'>
                        <h4>Follow Us</h4>
                        <Link>
                            <BsInstagram />
                        </Link>
                        <Link to={'https://www.linkedin.com/in/kavitakanwar/'}>
                            <BsLinkedin />
                        </Link>
                        <Link to={'https://github.com/Kavii1'}>
                            <BsGithub />
                        </Link>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;
